import React, {useState, useEffect} from "react";
import NavMain from "../components/nav/NavMain";
import HeaderApplicant from "../components/header/HeaderApplicant";
import { useParams } from "react-router-dom";
import axios from "axios";
import { format } from 'date-fns';
import GLOBALVAR from "../constants";
import { Col, Container, Row, Button, Modal } from "react-bootstrap";
import EditApplicant from "../components/modals/EditApplicant";
import { useNavigate } from 'react-router-dom';
import ApplicantProcessedLoans from "../components/misc/ApplicantProcessedLoans";


function ApplicantPage() {
    const { id } = useParams();
    const [applicant, setApplicant] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [showModalDelete, setShowModalDelete] = useState(false);
    const handleClose = () => setShowModal(false);
    const handleShow = () => setShowModal(true);
    const handleCloseDelete = () => setShowModalDelete(false);
    const handleShowDelete = () => setShowModalDelete(true);
    const [loanProcessed, setLoanProcessed] = useState(null);
    const navigate = useNavigate();

    const fetchApplication = async (id) => {
        try {
            const response = await axios.get(`${GLOBALVAR['SERVER_ROOT']}/api/applications/${id}`); // Replace '/api/applications/' with your actual endpoint
            const application = response.data;
            // Display application data in the frontend
            console.log(application);

            setLoanProcessed(application.loanProcessings);
            setApplicant(application);
        } catch (error) {
            console.error('Error fetching application:', error);
            // Handle error
        }
    };

    const handleDeleteProcess = async(id) => {
        // If id is null, do nothing
        if (!id) {
            return;
        }
        
        try {
            const response = await axios.post(`${GLOBALVAR['SERVER_ROOT']}/api/applications/delete/${id}`); 
            const application = response.data;
            console.log(application);
            // Display application data in the frontend
            navigate('/');
        } catch (error) {
            console.error('Error fetching application:', error);
            // Handle error
        }
    };


    // Function to update the applicant state in the parent component
    const updateParentApplicant = (newApplicantData) => {
        setApplicant(newApplicantData);
    };

    useEffect(() => {
        fetchApplication(id);
    }, [id]);

    return (
        <>
            <Modal show={showModal} onHide={handleClose} className="edit-app-details">
                <Modal.Header closeButton>
                    <Modal.Title>Edit Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <EditApplicant applicantdb={applicant} updateParentApplicant={updateParentApplicant} />
                </Modal.Body>
            </Modal>
            <Modal show={showModalDelete} onHide={handleCloseDelete} className="delete-app-details">
                <Modal.Header closeButton>
                    <Modal.Title className="h6">Are you sure you want to delete Applicant?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="d-flex justify-content-center">
                        <Button variant="primary" className="me-2" onClick={handleCloseDelete}>No</Button>
                        <Button variant="warning" onClick={() => handleDeleteProcess(applicant?applicant.id:null)}>Yes</Button>
                    </div>
                </Modal.Body>
            </Modal>
            <NavMain />
            <HeaderApplicant  applicant={applicant}/>
            <div className="main-content applicant-page">
                <div className="quick-links">
                    <Button variant="primary" onClick={handleShow}><i className="fa-solid fa-pencil"></i> Edit Details</Button>
                    <Button variant="primary" href={`/loan-processing/?id=${id}`}><i className="fa-solid fa-spinner"></i> Process Loan</Button>
                    <Button variant="warning" onClick={handleShowDelete}><i className="fa-solid fa-trash"></i> Send to Trash</Button>
                </div>
                <Container className="parent-container">
                    <Row>
                        <Col className="applicant-details">
                            <Row>
                                <Col className="title">Last Name</Col>
                                <Col className="value">{applicant ? applicant.lastName:''}</Col>
                            </Row>
                            <Row>
                                <Col className="title">First Name</Col>
                                <Col className="value">{applicant ? applicant.firstName:''}</Col>
                            </Row>
                            <Row>
                                <Col className="title">Middle Name</Col>
                                <Col className="value">{applicant ? applicant.middleName:''}</Col>
                            </Row>
                            <Row>
                                <Col className="title">Mother's Maiden Name</Col>
                                <Col className="value">{applicant ? applicant.mothersMaidenName:''}</Col>
                            </Row>
                            <Row>
                                <Col className="title">House / Street Address</Col>
                                <Col className="value">{applicant ? applicant.street:''}</Col>
                            </Row>
                            <Row>
                                <Col className="title">Barangay</Col>
                                <Col className="value">{applicant ? applicant.barangay:''}</Col>
                            </Row>
                            <Row>
                                <Col className="title">City / Municipality</Col>
                                <Col className="value">{applicant ? applicant.municipality:''}</Col>
                            </Row>
                            <Row>
                                <Col className="title">Province</Col>
                                <Col className="value">{applicant ? applicant.province:''}</Col>
                            </Row>
                            <Row>
                                <Col className="title">Zip Code</Col>
                                <Col className="value">{applicant ? applicant.zipCode:''}</Col>
                            </Row>
                            <Row>
                                <Col className="title">Birthday</Col>
                                <Col className="value">{applicant ? format(applicant.birthday, 'MM/dd/yyyy'):''}</Col>
                            </Row>
                            <Row>
                                <Col className="title">Gender</Col>
                                <Col className="value">{applicant ? applicant.gender:''}</Col>
                            </Row>
                            <Row>
                                <Col className="title">Civil Status</Col>
                                <Col className="value">{applicant ? applicant.civilStatus:''}</Col>
                            </Row>
                            <Row>
                                <Col className="title">Married To</Col>
                                <Col className="value">{applicant ? applicant.marriedTo:''}</Col>
                            </Row>
                            <Row>
                                <Col className="title">Telephone No.</Col>
                                <Col className="value">{applicant ? applicant.telephoneNo:''}</Col>
                            </Row>
                            <Row>
                                <Col className="title">Mobile No. 1</Col>
                                <Col className="value">{applicant ? applicant.mobileNo1:''}</Col>
                            </Row>
                            <Row>
                                <Col className="title">Mobile No. 2</Col>
                                <Col className="value">{applicant ? applicant.mobileNo2:''}</Col>
                            </Row>
                            <Row>
                                <Col className="title">Email Address</Col>
                                <Col className="value">{applicant ? applicant.emailAddress:''}</Col>
                            </Row>
                            <Row>
                                <Col className="title">SSS / GSIS #</Col>
                                <Col className="value">{applicant ? applicant.sssOrGsis:''}</Col>
                            </Row>
                            <Row>
                                <Col className="title">Passport #</Col>
                                <Col className="value">{applicant ? applicant.passport:''}</Col>
                            </Row>
                            <Row>
                                <Col className="title">Employer Details</Col>
                                <Col className="value">{applicant ? applicant.employerDetails:''}</Col>
                            </Row>
                            <Row>
                                <Col className="title">Employer Address</Col>
                                <Col className="value">{applicant ? applicant.employerAddress:''}</Col>
                            </Row>
                            <Row>
                                <Col className="title">Employer Contact No.</Col>
                                <Col className="value">{applicant ? applicant.employerContactNumber:''}</Col>
                            </Row>
                            <Row>
                                <Col className="title">Employer Location</Col>
                                <Col className="value">{applicant ? applicant.employerLocation:''}</Col>
                            </Row>
                        </Col>
                        <Col>
                            <div className="loan-list">
                                <h1>Processed Loans</h1>
                                {loanProcessed && (
                                    loanProcessed.map((loan, index) => {
                                        return (
                                            <ApplicantProcessedLoans key={index} date={loan.dateGranted} interval={loan.loanInterval} term={loan.loanTerm} amount={loan.amountGranted} interest={loan.interestRate} paymentList={loan.payments} id={loan.id} />
                                        );
                                    }))
                                }
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
}

export default ApplicantPage;